export const STO_CHECK_ROUTE_ROOT = '/sto-check';

export const STO_CHECK_ROUTES = {
  STO_CHECK: STO_CHECK_ROUTE_ROOT,
  CHECK_BASKET: `${STO_CHECK_ROUTE_ROOT}/check-basket`,
  CHECK_SUMMARY: `${STO_CHECK_ROUTE_ROOT}/summary`,
} as const;
